module.exports = __webpack_public_path__ + "static/img/banner01.502ed798.webp";